import { useCoreAuth } from '@carvana/core-auth';
import { useContext, useEffect } from 'react';
import UserContext from '~/context/srp/UserContext';

export default function useGetUserState() {
  const { getUserState } = useCoreAuth();
  const userState = getUserState();
  const {
    userState: { setData }
  } = useContext(UserContext);

  useEffect(() => {
    setData(userState);
  }, [setData, userState]);
}
